import { j as e } from "../../jsx-runtime-Wav_3Wde.js";
import { useState as g } from "react";
import { styled as f } from "styled-components";
import j from "../../Button/Button.mjs";
import { Flex as w, Box as y } from "../../Flexbox/Flexbox.mjs";
import b from "../../Legend/Legend.mjs";
import { Modal as C, ModalContent as A } from "../../Modal/Modal.mjs";
import h from "../../RadioGroup/Radio.mjs";
import M from "../../RadioGroup/RadioGroup.mjs";
import { a as W } from "../../brands-CoixlYYY.js";
import { useBrand as B } from "../../providers/BrandProvider/brandProvider.mjs";
import S from "../../typography/Link/Link.mjs";
import a from "../../typography/Paragraph/Paragraph.mjs";
import x from "../../typography/Text/Text.mjs";
import "../../typography/Heading/Heading.mjs";
import "./HideOnError.mjs";
import I from "./cookieBannerPolicyLinks.mjs";
import "../FullPageCookieBanner/FullPageHideOnError.mjs";
import q from "../utils/getAcceptedLevel.mjs";
const m = ({ title: o, subheading: i, name: r, onToggle: t, hasAlreadyAccepted: s }) => {
  const d = t != null;
  return /* @__PURE__ */ e.jsx(R, {
    "data-qa-id": "cookie-banner-level-agreement",
    children: /* @__PURE__ */ e.jsxs(y, {
      as: "fieldset",
      border: "unset",
      p: "unset",
      m: "unset",
      children: [
        /* @__PURE__ */ e.jsx(b, {
          pl: "unset",
          mt: "unset",
          mb: "xs",
          children: o
        }),
        /* @__PURE__ */ e.jsx(a, {
          mb: "xs",
          children: i
        }),
        d && /* @__PURE__ */ e.jsxs(M, {
          "aria-hidden": !0,
          name: r,
          variant: "horizontal",
          onCheck: (l) => {
            t == null || t(l === "yes");
          },
          defaultValue: s ? "yes" : "no",
          children: [
            /* @__PURE__ */ e.jsx(h, {
              "data-qa-id": `${r}-yes-radio`,
              value: "yes",
              children: /* @__PURE__ */ e.jsx(x, {
                children: "Yes"
              })
            }),
            /* @__PURE__ */ e.jsx(h, {
              "data-qa-id": `${r}-no-radio`,
              value: "no",
              wrapperProps: {
                marginBottom: 0
              },
              children: /* @__PURE__ */ e.jsx(x, {
                children: "No"
              })
            })
          ]
        })
      ]
    })
  });
}, _ = ({ isOpen: o, onClose: i, setCookieLevel: r, allowList: t = W, policyLinks: s = I, rootId: d = "root" }) => {
  const l = B(t), p = q(), [c, k] = g({
    allowSiteImprovementCookies: p.includes(2),
    allowAdvertisingCookies: p.includes(3)
  }), u = (n) => {
    k((v) => ({
      ...v,
      ...n
    }));
  };
  return /* @__PURE__ */ e.jsxs(C, {
    id: "cookie-banner-preferences",
    "data-qa-id": "cookie-banner-preferences",
    heading: "Manage your cookies",
    showHeading: !1,
    isOpen: o,
    rootId: d,
    onClose: i,
    modalWrapperProps: {
      width: [
        "80%",
        null,
        null,
        "50%"
      ]
    },
    ModalContentWrapper: L,
    children: [
      /* @__PURE__ */ e.jsx(a, {
        fontWeight: "semiBold",
        textAlign: "left",
        my: "auto",
        children: "Manage your cookies"
      }),
      /* @__PURE__ */ e.jsx(a, {
        my: "xs",
        children: "We use cookies to improve your experience on our website. Some are essential to keep you safe while looking around, but others can be tweaked depending on what you're happy with."
      }),
      /* @__PURE__ */ e.jsx(m, {
        title: "Essential cookies",
        name: "essential-cookies",
        subheading: "We need these to keep our website safe and running smoothly.",
        hasAlreadyAccepted: !0
      }),
      /* @__PURE__ */ e.jsx(m, {
        title: "Site improvement cookies",
        name: "site-improvement-cookies",
        subheading: "These help us track and understand how our website is performing.",
        onToggle: (n) => u({
          allowSiteImprovementCookies: n
        }),
        hasAlreadyAccepted: c.allowSiteImprovementCookies
      }),
      /* @__PURE__ */ e.jsx(m, {
        title: "Advertising cookies",
        name: "advertising-cookies",
        subheading: "These help to make sure that you're shown ads that are relevant to you.",
        onToggle: (n) => u({
          allowAdvertisingCookies: n
        }),
        hasAlreadyAccepted: c.allowAdvertisingCookies
      }),
      /* @__PURE__ */ e.jsxs(w, {
        flexDirection: "column",
        alignItems: "center",
        mx: "auto",
        children: [
          /* @__PURE__ */ e.jsx(j, {
            variant: "secondary",
            mt: "xs",
            mx: "auto",
            mb: [
              "xs",
              null,
              "unset"
            ],
            "data-qa-id": "save-preferences-button",
            maxWidth: "40rem",
            onClick: () => {
              r(c), i();
            },
            children: "Save preferences"
          }),
          /* @__PURE__ */ e.jsxs(a, {
            mt: "md",
            children: [
              "To find out more,",
              " ",
              /* @__PURE__ */ e.jsx(S, {
                href: s[l],
                external: !0,
                children: "see our Cookie Policy"
              })
            ]
          })
        ]
      })
    ]
  });
}, R = /* @__PURE__ */ f.div.withConfig({
  componentId: "sc-158bd09d-0"
})([
  "",
  ""
], ({ theme: o }) => o.components.cookieBannerModal.informationWrapper), L = /* @__PURE__ */ f(A).withConfig({
  componentId: "sc-158bd09d-1"
})([
  "",
  ""
], ({ theme: o }) => o.components.cookieBannerModal.roundedModalContentWrapper);
export {
  _ as default
};
